import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UploadedFileListService } from './uploaded-file-list.service';
import { RightSideDrawerService } from '../right-side-drawer/right-side-drawer.service';
import { FileService } from 'src/app/shared/file-service/file.service';
import { File } from '../models/file-upload-response.model';
import { APP_CONSTANTS, EXPENSE_SURVEY_CONSTANTS } from 'src/app/shared/constants/app-constants';
import { FileImportStatusEnum } from '../constants/file-import-status.enum';
import { FileTypeEnum } from '../constants/file-type.enum';

@Component({
  selector: 'uploaded-file-list',
  templateUrl: './uploaded-file-list.component.html',
  styleUrls: ['./uploaded-file-list.component.scss']
})
export class UploadedFileListComponent implements OnInit {
  @Input() fileType: number;
  @Input() engagementId: number;
  @Output() showFileImportSection = new EventEmitter<boolean>();
  errorToolTip = '';
  warningToolTip = 'Completed with warning';
  uploadedFiles: File[];  
  fileImportStatusEnum: typeof FileImportStatusEnum = FileImportStatusEnum;  
  fileTypeEnum: typeof FileTypeEnum = FileTypeEnum;
  constructor(
    private uploadedFileListService: UploadedFileListService,
    public rightSideDrawerService: RightSideDrawerService,
    private _fileService: FileService
  ) { }

  ngOnInit(): void {
    this.rightSideDrawerService.spinnerLoad(true);
    if(this.fileType === this.fileTypeEnum.Employee)
    {
      this.errorToolTip = APP_CONSTANTS.PAYROLL_DATA_FILE_ERROR_MESSAGE;
    }else if(this.fileType === this.fileTypeEnum.Project)
    {
      this.errorToolTip = APP_CONSTANTS.PROJECT_DATA_FILE_ERROR_MESSAGE;

    }else if(this.fileType === this.fileTypeEnum.ExpenseData){
      this.errorToolTip = APP_CONSTANTS.EXPENSE_DATA_FILE_ERROR_MESSAGE;
    }
    this.uploadedFileListService.getEmployeeFiles(this.engagementId, this.fileType, true).subscribe((data: any) => {
      this.rightSideDrawerService.spinnerLoad(false);
      this.uploadedFiles = data.result;
      if(this.uploadedFiles && this.uploadedFiles.length > 0){
        this.showFileImportSection.emit(true);
      }
    });
  }
  downloadFile(row: File) {
    this.rightSideDrawerService.spinnerLoad(true);
    this.uploadedFileListService.downloadUploadedFile(this.engagementId, row.fileId, this.fileType).subscribe(
      blob => {
        const fileName: string = row.fileName.substring(row.fileName.length - 5, 0) + ' Report';
        const extention = '.xlsx';
        this._fileService.saveBlobToFile(blob, fileName + extention)
        this.rightSideDrawerService.spinnerLoad(false);
      });
  }

}
